import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./getters"
import menu from "./modules/menu"

Vue.use(Vuex)

const state = {

}
const store = new Vuex.Store({
  modules: {
    menu
  },
  getters
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js